export const INTERNAL_CURRENCY_CODE = 'CSF';
